/* SiteTypeComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./SiteTypeRenderer");
const _ = require("lodash");

class LocationTypeComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._context = context;
        this._locationLabels = context._labels;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLocationType(newVal);
        }
    }

    getValue() {
        return this.getLocationType();
    }

    setLocationType(newVal) {
        this._value = newVal;
        this.emit("LocationType", newVal);
        return this;
    }

    getLocationType() {
        return this._value;
    }

    getIconData() {
        this._labels = _.get(this._context, "_labels", {});

        if (!this._value) {
            return { icon: "siteexplorer.site", title: "Site" };
        }

        return { icon: "siteexplorer." + _.snakeCase(this._labels[this._value]), title: this._labels[this._value] };
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = LocationTypeComponent;
